import { ShareAltOutlined, UserSwitchOutlined } from '@ant-design/icons';
import { t } from '@hefe/i18n';
import { Inventory } from '@hefe/models';
import { currentUserSelector, InventoryApi } from '@hefe/store';
import { Button, Popconfirm, Tooltip } from 'antd';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { environment } from '../../../../../environments/environment';
import { useAppDispatch } from '../../../../store/store';

interface UserInventoryListItemShareComponentProps {
  inventory: Inventory;
}

export default function UserInventoryListItemShareComponent(
  props: UserInventoryListItemShareComponentProps
) {
  const { inventory } = props;

  const dispatch = useAppDispatch();
  const user = useSelector(currentUserSelector);

  const [createShareLink, { isLoading: isCreatingShareLink }] =
    InventoryApi.useCreateShareLinkMutation();

  const button = useMemo(() => {
    if (inventory.active_share_transfer_id) {
      return (
        <Popconfirm
          key="show_share_link"
          title={`${environment.frontendUrl}/#/user/inventories/${inventory.active_share_transfer_id}`}
        >
          <Button
            key="show_share_link"
            type="text"
            icon={<ShareAltOutlined />}
          />
        </Popconfirm>
      );
    } else if (inventory.possessor_id === user?.id) {
      return (
        <Popconfirm
          key="create_share_link"
          title={t('inventory.transfers.share.create.description')}
          onConfirm={() => createShareLink(inventory)}
          disabled={isCreatingShareLink}
        >
          <Tooltip title={t('inventory.transfers.share.create.title')}>
            <Button
              key="create_share_link"
              type="text"
              icon={<UserSwitchOutlined />}
              loading={isCreatingShareLink}
            />
          </Tooltip>
        </Popconfirm>
      );
    }

    return;
  }, [createShareLink, inventory, isCreatingShareLink, user?.id]);

  return button;
}
